var map = {
	"./scan_changtong.png": "VuVo",
	"./scan_hewego.png": "PDtf",
	"./scan_udian.png": "USjl",
	"./scan_xiaoxiangui.png": "G5Dq",
	"./scan_ylLive.png": "8cdb",
	"./scan_yumofang.png": "ZWgd",
	"./scan_yyagro.png": "AEVu"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "robg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shopHome ^\.\/scan_.*\.png$
// module id = robg
// module chunks = 51